export const apiField = 'velocity_pressure_exposure_coefficient_kz';
export default {
  type: 'Text',
  label: 'VelocityPressureExposureCoefficientKz',
  missing: undefined,
  apiField,
  tooltip: undefined,
};

